import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

const styles = ({ spacing }: Theme) =>
  createStyles({
    paper: {
      position: 'relative',
    },
    scrollable: {
      height: 340,
      overflowY: 'auto',
    },
  })

export default makeStyles(styles)
